import { api } from './client';
import type {
  Equipment,
  EquipmentCreate,
  EquipmentUpdate,
  EquipmentListResponse,
  EquipmentCategoriesResponse,
} from '@/types/equipment';

export const equipmentApi = {
  /**
   * Get available equipment categories and subcategories.
   */
  async getCategories(): Promise<EquipmentCategoriesResponse> {
    return api.get('/api/equipment/categories');
  },

  /**
   * List equipment for a tank.
   */
  async list(
    tankId: string,
    params?: { status?: string; category?: string }
  ): Promise<EquipmentListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.status) searchParams.set('status', params.status);
    if (params?.category) searchParams.set('category', params.category);

    const query = searchParams.toString();
    const url = `/api/tanks/${tankId}/equipment${query ? `?${query}` : ''}`;
    return api.get(url);
  },

  /**
   * Get a single equipment item.
   */
  async get(tankId: string, equipmentId: string): Promise<Equipment> {
    return api.get(`/api/tanks/${tankId}/equipment/${equipmentId}`);
  },

  /**
   * Create new equipment.
   */
  async create(tankId: string, data: EquipmentCreate): Promise<Equipment> {
    return api.post(`/api/tanks/${tankId}/equipment`, data);
  },

  /**
   * Update equipment.
   */
  async update(
    tankId: string,
    equipmentId: string,
    data: EquipmentUpdate
  ): Promise<Equipment> {
    return api.put(`/api/tanks/${tankId}/equipment/${equipmentId}`, data);
  },

  /**
   * Delete equipment.
   */
  async delete(tankId: string, equipmentId: string): Promise<void> {
    return api.delete(`/api/tanks/${tankId}/equipment/${equipmentId}`);
  },
};
